const fieldRequired = (value) => (value ? undefined : 'Field is required');

export default fieldRequired;
